import { MenuButton, MenuGroup } from '@frameio/vapor';
import { IconChatQuestionMark } from '@frameio/vapor-icons';
import { ContactSupportMenuItem } from './ContactSupportMenuItem';
import TEXT from './generated/TEXT/HelpAndSupportMenuItem';
import { SubmitFeedbackMenuItem } from './SubmitFeedbackMenuItem';

TEXT.DEFINE({
  /** Help and support menu item label */
  label: 'Help & Support',
});

export const HelpAndSupportMenuItem = () => {
  return (
    <MenuButton
      iconBefore={<IconChatQuestionMark />}
      submenu={
        <MenuGroup>
          <ContactSupportMenuItem />
          <SubmitFeedbackMenuItem />
        </MenuGroup>
      }
    >
      {TEXT.label}
    </MenuButton>
  );
};
